import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import("@/components/pages/HomePage.vue"),
  },
  {
    path: "/projects",
    name: "Projects",
    component: () => import("@/components/pages/ProjectsPage.vue"),
  },
  {
    path: "/resume",
    name: "Resume",
    component: () => import("@/components/pages/ResumePage.vue"),
  },
  {
    path: "/blog",
    name: "Blog",
    component: () => import("@/components/pages/BlogPage.vue"),
  },
  {
    path: "/blog/career-mistakes-adhd-autism",
    name: "CareerMistakes",
    component: () => import("@/components/pages/blog/CareerMistakes.vue"),
  },
  {
    path: "/blog/component-library-surprises",
    name: "ComponentLibrarySurprises",
    component: () => import("@/components/pages/blog/ComponentLibrarySurprises.vue"),
  },
  {
    path: "/blog/ai-future-is-here-and-its-weird",
    name: "AiFutureIsHereAndItsWeird",
    component: () => import("@/components/pages/blog/AiFutureIsHereAndItsWeird.vue"),
  },
  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: () => import("@/views/NotFound.vue"),
  },
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

export default router;
